import { useCarInsuranceContext } from 'car-insurance/context';
import { trackCIGetQuoteButton } from 'car-insurance/tracking';
import { Icon } from '../Icon';
import { CTAButton } from './CTAButton';

const GetQuoteButton: React.FC<{ title?: string }> = ({
  title = 'Get Quote',
}) => {
  const {
    dialogs: { quoteDetailsDialog },
  } = useCarInsuranceContext();
  return (
    <div className="md:w-43 w-full">
      <CTAButton
        onClick={() => {
          trackCIGetQuoteButton();
          quoteDetailsDialog.setIsOpen(true);
        }}
      >
        {title}
        <Icon
          useGoogleMaterial
          name="arrow_right_alt"
          className="text-white alpha-button-1"
        />
      </CTAButton>
    </div>
  );
};

export { GetQuoteButton };
